import { CldImage } from "next-cloudinary";
import styles from "./AffiliateDisclaimer.module.scss";

export default function AffiliateDisclaimer({}) {
  return (
    <div className={`${styles.container}`}>
      <div className={`${styles.iconWrapper}`}>
        <CldImage
          src="https://res.cloudinary.com/dail4fbms/image/upload/v1697102874/one_percent_for_the_planet_fcfd832d57.png"
          fill
          sizes={`(min-width: 320px) 368px`}
          alt="One Percent for the Planet logo"
          className={`${styles.icon}`}
        />
      </div>
      <p className={`${styles.text}`}>
        This article contains affiliate links for our preferred providers. 1% of
        all revenue goes to 1% for the Planet approved charities.
      </p>
    </div>
  );
}
